module.exports = __webpack_public_path__ + "img/Premium_1_scg.90c93e82.svg";